module.exports = {"id":"168965","name":"Rémy Riou","rating":"73","photo":"./data/images/photos/1/168965.png","club":{"name":"Aytemiz Alanyaspor","logo":"./data/images/clubs/AytemizAlanyaspor.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RemyRiou0.json
// module id = 3566
// module chunks = 0